import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useApi from '@/hooks/useApi';
import useApp from '@/pages/App.context';
import styles from './Cancel.module.scss';

const Cancel = () => {
  const { t } = useTranslation(['sign']);
  const { setAppTitle } = useApp();
  const { workflowId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [abortSigning] = useApi('sign.abort');

  // Send abort info to the backend
  useEffect(() => {
    const token = searchParams.get('key');

    if (!workflowId || (!token && !sessionStorage.getItem('token'))) {
      void navigate('/', { replace: true });
    } else {
      if (token) {
        localStorage.setItem('token', token);
        sessionStorage.setItem('token', token);
      }

      void abortSigning({ workflowId });
    }
  }, [abortSigning, navigate, searchParams, workflowId]);

  useEffect(() => {
    setAppTitle(t('sign:cancel.title'));
  }, [setAppTitle, t]);

  return (
    <div className={styles.pane}>
      <h1 className={styles.h1}>{t('sign:cancel.headline')}</h1>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: t('sign:cancel.desc').replaceAll('\n', '<br>'),
        }}
      />
    </div>
  );
};

export default Cancel;
